// assets
import {
  IconDashboard,
  IconBrandChrome,
  IconStack,
  IconReportAnalytics,
  IconTimeline,
  IconFileAnalytics,
  IconFilePower,
  IconFileTime,
  IconGauge,
  IconCalendarStats,
  IconCalendarTime,
  IconChartLine,
  IconMapPin,
  IconDeviceTv
} from '@tabler/icons';

// constant
const icons = {
  IconDashboard,
  IconBrandChrome,
  IconStack,
  IconReportAnalytics,
  IconTimeline,
  IconFileAnalytics,
  IconFilePower,
  IconFileTime,
  IconGauge,
  IconCalendarStats,
  IconMapPin,
  IconChartLine,
  IconDeviceTv
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  type: 'group',
  children: [
    {
      id: 'dsp-header',
      title: 'InMobi DSP',
      type: 'header' // Add this as a header for DSP items
    },
    {
      id: 'default',
      title: 'Overview',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconGauge,
      breadcrumbs: false
    },
    {
      id: 'dsp',
      title: 'DSP Overview',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconGauge,
      breadcrumbs: false
    },
    {
      id: 'reporting',
      title: 'Publisher App Report',
      type: 'item',
      url: '/reporting',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
    {
      id: 'creative',
      title: 'Creative Report',
      type: 'item',
      url: '/creative',
      icon: icons.IconFileAnalytics,
      breadcrumbs: false
    },
    {
      id: 'rawevents',
      title: 'Raw Event Report',
      type: 'item',
      url: '/rawevents',
      icon: icons.IconFilePower,
      breadcrumbs: false
    },
    {
      id: 'statereport',
      title: 'State Level Report',
      type: 'item',
      url: '/statereport',
      icon: icons.IconMapPin,
      breadcrumbs: false
    },
    {
      id: 'wow',
      title: 'WoW Report',
      type: 'item',
      url: '/wow',
      icon: icons.IconFileTime,
      breadcrumbs: false
    },
    {
      id: 'dod',
      title: 'DoD Report',
      type: 'item',
      url: '/dod',
      icon: icons.IconCalendarStats,
      breadcrumbs: false
    },
    {
      id: 'iap-header',
      title: 'IAP',
      type: 'header' // Add this as a header for IAP items
    },
    {
      id: 'iap',
      title: 'IAP Overview',
      type: 'item',
      url: '/iap',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'd2c-header',
      title: 'Commerce',
      type: 'header' // Add this as a header for D2C items
    },
    {
      id: 'd2c',
      title: 'Overview Report',
      type: 'item',
      url: '/d2c',
      icon: icons.IconCalendarStats,
      breadcrumbs: false
    },
    {
      id: 'ctv-header',
      title: 'CTV',
      type: 'header'
    },
    {
      id: 'ctv',
      title: 'CTV Overview',
      type: 'item',
      url: '/ctv',
      icon: icons.IconDeviceTv,
      breadcrumbs: false
    },
    {
      id: 'gtv-header',
      title: 'GTV',
      type: 'header'
    },
    {
      id: 'gtv',
      title: 'GTV Overview',
      type: 'item',
      url: '/gtv',
      icon: icons.IconDeviceTv,
      breadcrumbs: false
    },
    {
      id: 'admin',
      title: 'Admin Panel',
      type: 'item',
      url: '/pages/admin',
      icon: icons.IconBrandAsana,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
